import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from '../../../components/forms/Checkbox';
import { t } from '../../../utilities/translator';

export default function MobileFilterItem(props) {
  const { name, handleCheckbox, localFilter, filterName } = props;

  const renderCheckbox = localFilter.map(({ value, label, active }, index) => {
    const labelName = filterName === 'facilities' ? label.name : label
    return (
      <Checkbox
        key={value}
        label={
          name === t('secondaryFilter.property_class')
            ? labelName +
              ' ' + t('secondaryFilter.stars_plural', {  count: value })
            : labelName
        }
        checked={active}
        onChange={() => handleCheckbox(index)}
      />
    );
  });

  return (
    <div className="filter-item">
      <p className="filter-item__name">
        <span>{name}</span>
      </p>
      <div className="filter-body">
        {renderCheckbox}
      </div>
    </div>
  );
}

MobileFilterItem.propTypes = {
  name: PropTypes.string.isRequired,
};
